<template>
  <div class="pdf-sidebar">
    <div class="sidebar-header">
      <h3>Catálogos Disponibles</h3>
    </div>
    
    <div class="pdf-list">
      <div v-if="loading && pdfList.length === 0" class="loading-state">
        <v-progress-circular indeterminate size="40" />
        <span>Cargando catálogos...</span>
      </div>
      
      <div v-else-if="pdfList.length === 0" class="empty-state">
        <v-icon large color="grey">mdi-file-pdf-box</v-icon>
        <p>No hay catálogos disponibles</p>
      </div>
      
      <v-list v-else dense>
        <v-list-item
          v-for="pdf in pdfList"
          :key="pdf.id || pdf.idBrochure"
          @click="selectPdf(pdf)"
          :class="{ 'active': isActive(pdf) }"
          class="pdf-item"
        >
          <v-list-item-icon>
            <v-icon :color="isActive(pdf) ? 'white' : 'primary'">
              mdi-file-pdf-box
            </v-icon>
          </v-list-item-icon>
          
          <v-list-item-content>
            <v-list-item-title :class="{ 'white--text': isActive(pdf) }">
              {{ pdf.name || pdf.filename }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="pdf.description" :class="{ 'white--text': isActive(pdf) }">
              {{ pdf.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfSidebar',
  props: {
    pdfList: {
      type: Array,
      default: () => []
    },
    currentPdf: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectPdf(pdf) {
      this.$emit('select-pdf', pdf);
    },
    
    isActive(pdf) {
      if (!this.currentPdf) return false;
      return (pdf.id && pdf.id === this.currentPdf.id) ||
             (pdf.idBrochure && pdf.idBrochure === this.currentPdf.idBrochure);
    }
  }
};
</script>

<style scoped>
.pdf-sidebar {
  width: 300px;
  background: #f8f9fa;
  border-right: 1px solid #dee2e6;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-header {
  padding: 15px;
  background: #e9ecef;
  border-bottom: 1px solid #dee2e6;
}

.sidebar-header h3 {
  font-size: 16px;
  margin: 0;
  color: #495057;
}

.pdf-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  min-height: 0; /* Important for flex items to shrink properly */
  height: 100%;
}

.loading-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
}

.loading-state span {
  margin-top: 15px;
  font-size: 14px;
}

.empty-state p {
  margin: 10px 0 5px;
  font-size: 14px;
}

.pdf-item {
  margin-bottom: 5px;
  border-radius: 6px;
  transition: all 0.2s;
}

.pdf-item:hover {
  background: #e3f2fd !important;
}

.pdf-item.active {
  background: #2196f3 !important;
}

/* Scrollbar styling */
.pdf-list::-webkit-scrollbar {
  width: 6px;
}

.pdf-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.pdf-list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.pdf-list::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Responsive design */
@media (max-width: 768px) {
  .pdf-sidebar {
    width: 100%;
    max-height: 200px;
    border-right: none;
    border-bottom: 1px solid #dee2e6;
  }
}
</style>